// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Standard from "./pages/Standard";
import Product from "./pages/Products";
import EasyLearnLMS from "./pages/easylearn-lms";
import EasyTutor from "./pages/easytutor";
import SkillMaster from "./pages/skill-master";
import MarketingApproach from "./pages/marketing_approach";
import MarketingChannel from "./pages/marketing_channel";
import MarketingTarget from "./pages/marketing_target";
import MarketingStrategy from "./pages/marketing_Strategy";
import JoinAndEarn from "./pages/join_and_earn";
import Marketing from "./pages/Marketing";
import TraditionalMarketing from './pages/TraditionalMarketing';
import DigitalMarketing from './pages/DigitalMarketing';
import InboundMarketing from './pages/InboundMarketing';
import Reference from "./pages/reffrence";
import Navbar from "./components/Navbar";
import CourseWare from "./pages/courseware";
import Login from "./pages/login";
import Signup from "./pages/signup.js";
import AddModal from "./pages/addmodal.js";
import SuperAdminDashboard from "./pages/Superadmindashboard.js";
import Superadmin from "./pages/Superadmin.js"; // GrowthOS SuperAdmin panel — info@isfathena.com login
import AddProduct from "./pages/addproduct.js";
import NoteBuddy from "./pages/notebuddy.js";
import AthenaStar from "./pages/athenastar.js";
// import OutboundMarketing from "./pages/outbound-marketing.js";
import IsfAcademy from "./pages/Isfacademy.js";
import MentorBox from "./pages/mentorbox.js";
import Pitchdeck from "./pages/pitchdeck.js";
import WorkFlow from "./pages/workflow.js";
import Contact from "./pages/contact";
import ComingSoon from './pages/ComingSoon';
import CompanyRegister from './pages/company_register.js';
import CompanyDashboard from './pages/company_dashboard.js';
import CompanyHome from './pages/company_home.js';
import CompanyProduct from './pages/company_product.js';
import CompanyPrice from './pages/company_price.js';
import CompanyProductDashboard from './pages/company_product_dashboard.js';
import CompanyDashboardSidebar from './pages/company_Dashboard_sidebar.js';
import CompanyTeamPage from './pages/Company_Teampage.js';
import CompanySettings from './pages/CompanySettings.js';
// import Baatchit from "./pages/baatchit.js";
// Pages that already have their own sidebar/nav layout — the global
// ISF Athena Navbar would just duplicate/overlap it, so we hide it there.
const NO_NAVBAR_ROUTES = ["/company_home", "/company_dashboard", "/company_product", "/company_price", "/app", "/team", "/settings", "/growthos-admin"];

function AppLayout() {
  const location = useLocation();
  const hideNavbar = NO_NAVBAR_ROUTES.some(
    (path) => location.pathname === path || location.pathname.startsWith(`${path}/`)
  );

  return (
    <>
      {!hideNavbar && <Navbar />}

      {/* Define your routes here */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/standard" element={<Standard/>} />
        <Route path="/products" element={<Product />} />
        <Route path="/easylearn-lms" element={<EasyLearnLMS />} />
        <Route path="/easytutor" element={<EasyTutor/>} />
        <Route path="/skill-master" element={<SkillMaster/>} />
        <Route path="/marketing_approach" element={<MarketingApproach/>} />
        <Route path="/marketing_channel" element={<MarketingChannel/>} />
        <Route path="/marketing_target" element={<MarketingTarget/>} />
        <Route path="/marketing_Strategy" element={<MarketingStrategy/>} />
        <Route path="/marketing" element={<Marketing/>} />
        <Route path="/traditional-marketing" element={<TraditionalMarketing/>} />
        <Route path="/digital-marketing" element={<DigitalMarketing/>} />
        <Route path="/inbound-marketing" element={<InboundMarketing/>} />
        <Route path="/join_and_earn" element={<JoinAndEarn/>} />
        <Route path="/reffrence" element={<Reference/>} />
        <Route path="/courseware" element={<CourseWare/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/signup" element={<Signup/>} />
        <Route path="/addmodal" element={<AddModal/>} />
        <Route path="/Superadmindashboard" element={<SuperAdminDashboard/>} /> {/* ✅ FIXED: matches Navbar href="/admin" */}
        <Route path="/growthos-admin" element={<Superadmin/>} /> {/* GrowthOS SuperAdmin panel — reached via info@isfathena.com login */}
        <Route path="/addproduct" element={<AddProduct/>} /> 
        <Route path="/notebuddy" element={<NoteBuddy/>} /> 
        <Route path="/athenastar" element={<AthenaStar/>} />
        {/* <Route path="/outbound-marketing" element={<OutboundMarketing/>} /> */}
        <Route path="/isfacademy" element={<IsfAcademy/>} />
        <Route path="/mentorbox" element={<MentorBox/>} />
        <Route path="/pitchdeck" element={<Pitchdeck/>} />
        <Route path="/workflow" element={<WorkFlow/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/company_register" element={<CompanyRegister />} />
        <Route path="/company_dashboard" element={<CompanyDashboard />} />
        <Route path="/company_home" element={<CompanyHome />} />
        <Route path="/company_product" element={<CompanyProduct />} />
        <Route path="/company_price" element={<CompanyPrice />} />
        <Route path="/app/*" element={<CompanyProductDashboard />} />
        <Route path="/company_dashboard_sidebar" element={<CompanyDashboardSidebar />} />
        <Route path="/team" element={<CompanyTeamPage />} />
        <Route path="/settings" element={<CompanySettings />} />
        {/* <Route path="/baatchit" element={<Baatchit/>} /> */}
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;